import { Clock } from 'lucide-react';

// Shown for routes whose feature is disabled in this phased release (see backend
// ENABLED_FEATURES / App.js ProtectedLayout featureKey). Keeps the app shell so the
// sidebar + header stay usable; the user just can't reach the not-yet-released feature.
export default function ComingSoon() {
  return (
    <div className="flex flex-col items-center justify-center text-center py-24 px-6" data-testid="coming-soon">
      <div className="w-16 h-16 rounded-full bg-accent flex items-center justify-center mb-5">
        <Clock className="w-8 h-8 text-primary" />
      </div>
      <h1 className="text-2xl font-bold text-foreground mb-2" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
        Coming soon
      </h1>
      <p className="text-muted-foreground max-w-md">
        This feature isn’t available in the current release yet. It’s on the way — please check
        back soon.
      </p>
    </div>
  );
}
